export function parseLooseAddress(text) {
  const raw = (text || '').toString().trim();
  if (!raw) {
    return {};
  }
  const parts = raw
    .split(',')
    .map(short => short.trim())
    .filter(Boolean);

  // Regex pokrývá různé formáty PSČ, vždy bereme poslední shodu —
  // PSČ v formatted_address stojí za číslem popisným.
  //   UK:       [A-Z]{1,2}[0-9][A-Z0-9]? [0-9][A-Z]{2}  (SW1X 8AF, EC1A 1BB)
  //   Canada:   [A-Z][0-9][A-Z] [0-9][A-Z][0-9]          (M5V 3L9)
  //   CZ/SK:    \d{3}\s?\d{2}                              (130 00, 13000)
  //   5-digit:  \d{5}                                      (10115)
  //   4-6 dig:  \d{4,6}                                    (1051, 1010)
  const ZIP_RE =
    /\b[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}\b|\b[A-Z]\d[A-Z]\s?\d[A-Z]\d\b|\b\d{3}\s?\d{2}\b|\b\d{5}\b|\b\d{4,6}\b/gi;
  const zipMatch = raw.match(ZIP_RE);
  const zip = zipMatch ? zipMatch[zipMatch.length - 1].trim() : '';

  const countryGuess =
    parts
      .slice()
      .reverse()
      .find(part =>
        /(czech|česko|slovak|hungar|mexic|german|poland|austria|turk|uk|united kingdom|france|spain|italy)/i.test(
          part
        )
      ) ||
    parts[parts.length - 1] ||
    '';

  const cityGuess =
    parts.find(
      part => part !== countryGuess && !/^\d{3}\s?\d{2}$/.test(part) && !/^\d{4,6}$/.test(part)
    ) ||
    parts[0] ||
    '';

  return {
    formatted: raw,
    zip: zip,
    country: countryGuess,
    countryCode: '',
    city: cityGuess,
    streetName: '',
    streetNumber: '',
    lat: null,
    lon: null,
    placeId: null
  };
}

export function geocodeAddress(text) {
  return new Promise(resolve => {
    if (!(window.google && google.maps && google.maps.Geocoder)) {
      resolve({ ...parseLooseAddress(text) });
      return;
    }
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: text }, (results, status) => {
      if (status !== 'OK' || !results || !results.length) {
        resolve({ ...parseLooseAddress(text) });
        return;
      }
      const place = results[0];
      const comps = place.address_components || [];
      const get = type => comps.find(ac => Array.isArray(ac.types) && ac.types.includes(type));
      const country = get('country')?.long_name || '';
      const countryCode = get('country')?.short_name || '';
      const zip = get('postal_code')?.long_name || '';
      const city =
        get('locality')?.long_name ||
        get('postal_town')?.long_name ||
        get('administrative_area_level_2')?.long_name ||
        '';
      const streetName = get('route')?.long_name || '';
      const streetNumber = get('street_number')?.long_name || '';
      const lat = place.geometry?.location?.lat ? place.geometry.location.lat() : null;
      const lon = place.geometry?.location?.lng ? place.geometry.location.lng() : null;

      resolve({
        formatted: place.formatted_address || text,
        zip,
        country,
        countryCode,
        city,
        streetName,
        streetNumber,
        lat,
        lon,
        placeId: place.place_id || null
      });
    });
  });
}
